import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-job-openings', templateUrl: './job-openings.component.html', styleUrls: ['./job-openings.component.scss'] })
export class JobOpeningsComponent implements OnInit { constructor() { } ngOnInit(): void { } }
